import { registerArchetype } from './index.js';
import { applyDamage, computeDamage, livingEnemies, lowestHpEnemy, enemySide, effectiveAtk, effectiveDef } from '../combat.js';
registerArchetype({
    id: 'multi_hit',
    apply: ({ state, source, params, rng }) => {
        const hits = params.hits ?? 3;
        const mult = params.multiplierPerHit ?? 0.4;
        const targetMode = params.target ?? 'random';
        const sourceRt = (source.side === 'A' ? state.sideA : state.sideB)[source.slot];
        for (let i = 0; i < hits; i++) {
            const enemies = livingEnemies(state, source.side);
            if (enemies.length === 0)
                return;
            const target = targetMode === 'lowest_hp' ? lowestHpEnemy(state, source.side) : rng.pick(enemies);
            const dmg = computeDamage(effectiveAtk(sourceRt) * mult, effectiveDef(target.runtime));
            applyDamage(state, source, { side: enemySide(source.side), slot: target.slot }, dmg, false, rng);
        }
    }
});
